/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-08-21 10:16:45
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-25 10:10:54
 * @FilePath: /chaoyongtuan/src/store/modules/user/state/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const loginStatus = !!CookiesTools.getToken();
const vuex_userInfo = JSON.parse(localStorage.getItem('vuex_userInfo') || '[]');
const vuex_tenantId = localStorage.getItem('vuex_tenantId');
const vuex_userId = localStorage.getItem('vuex_userId');
const vuex_userTypeList = JSON.parse(localStorage.getItem('vuex_userTypeList') || '[]');
const vuex_dataViewId = sessionStorage.getItem('vuex_dataViewId') || '';
const vuex_dataViewList = JSON.parse(sessionStorage.getItem('vuex_dataViewList') || '[]');
const vuex_sphExpoName = localStorage.getItem('vuex_sphExpoName') || '';
const vuex_inviteData = JSON.parse(localStorage.getItem('vuex_inviteData') || '{}');
export default {
	loginStatus,
	vuex_userId: vuex_userId || '',
	vuex_userInfo: vuex_userInfo || {},
	vuex_tenantId: vuex_tenantId || '',
	vuex_userTypeList: vuex_userTypeList || '',
	vuex_dataViewId: vuex_dataViewId,
	vuex_dataViewList: vuex_dataViewList,
	vuex_sphExpoName: vuex_sphExpoName,
	vuex_inviteData: vuex_inviteData || {},
};
